var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHardHat = function SvgHardHat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20.34361,
    viewBox: "0 0 30 20.34361",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.01006,26.1718l-.00995-.00007-.00995.00007Z",
    transform: "translate(-1 -5.8282)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76811,25.16248a88.04185,88.04185,0,0,0,13.232,1.00925,88.04185,88.04185,0,0,0,13.232-1.00925A2.126,2.126,0,0,0,30.91589,22.476a3.20866,3.20866,0,0,0-1.36655-1.8908c-.13736-.09011-.15042-.44491-.15833-.67907a15.50844,15.50844,0,0,0-2.29552-8.00584A12.35876,12.35876,0,0,0,22.2639,7.47622c-.77979-.40132-.77594-.39422-1.12217.40608l-.85094,10.93312-1.10039-.41228s-.04493-11.64854,0-11.72691a.4864.4864,0,0,0-.46073-.58521A14.82468,14.82468,0,0,0,16.006,5.8282h-.01171a14.82444,14.82444,0,0,0-2.72368.26282.4864.4864,0,0,0-.46075.58521c.04492.07837,0,11.72691,0,11.72691l-1.1004.41228L10.85847,7.8823c-.34622-.8003-.34237-.8074-1.12215-.40608a12.35893,12.35893,0,0,0-4.8316,4.42411,15.50865,15.50865,0,0,0-2.29554,8.00584c-.0079.23416-.02094.589-.15829.67907A3.20858,3.20858,0,0,0,1.08432,22.476a2.126,2.126,0,0,0,1.68379,2.68644Z",
    transform: "translate(-1 -5.8282)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHardHat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hardHat.7e8ec05a.svg";
export { ForwardRef as ReactComponent };